import BlStepperStatusDotAv from './BlStepperStatusDotAv.vue'

BlStepperStatusDotAv.install = function(Vue) {
  Vue.component(BlStepperStatusDotAv.name, BlStepperStatusDotAv)
}

export default BlStepperStatusDotAv
